import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Agent,
  AgentCategory,
  AgentListResponse,
  AgentWritePayload,
  ModelCatalog,
  ToolCatalog,
} from '@interfaces/agent';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AgentsService {
  constructor(
    private apiService: ApiService,
    private http: HttpClient,
  ) {}

  getAgents = (): Observable<AgentListResponse | Agent[]> =>
    this.http.get<AgentListResponse | Agent[]>(this.apiService.getAgentsUrl());

  duplicateAgent = (uuid: string): Observable<Agent> =>
    this.http.post<Agent>(this.apiService.getAgentDuplicateUrl(uuid), {});

  deleteAgent = (uuid: string): Observable<void> => this.http.delete<void>(this.apiService.getAgentDetailUrl(uuid));

  getModelCatalog = (): Observable<ModelCatalog> =>
    this.http.get<ModelCatalog>(this.apiService.getAgentModelCatalogUrl());

  getToolCatalog = (): Observable<ToolCatalog> => this.http.get<ToolCatalog>(this.apiService.getAgentToolCatalogUrl());

  getAgent = (uuid: string): Observable<Agent> => this.http.get<Agent>(this.apiService.getAgentDetailUrl(uuid));

  createAgent = (body: AgentWritePayload): Observable<Agent> =>
    this.http.post<Agent>(this.apiService.getAgentsUrl(), body);

  updateAgent = (uuid: string, body: AgentWritePayload): Observable<Agent> =>
    this.http.patch<Agent>(this.apiService.getAgentDetailUrl(uuid), body);

  uploadAvatar = (uuid: string, image: Blob): Observable<Agent> => {
    const formData = new FormData();
    formData.append('image', image, 'avatar.jpg');
    return this.http.post<Agent>(this.apiService.getAgentAvatarUploadUrl(uuid), formData);
  };

  getCategories = (): Observable<{ results?: AgentCategory[] } | AgentCategory[]> =>
    this.http.get<{ results?: AgentCategory[] } | AgentCategory[]>(this.apiService.getAgentCategoriesUrl());

  createCategory = (name: string): Observable<AgentCategory> =>
    this.http.post<AgentCategory>(this.apiService.getAgentCategoriesUrl(), { name });

  updateCategory = (uuid: string, name: string): Observable<AgentCategory> =>
    this.http.patch<AgentCategory>(this.apiService.getAgentCategoryDetailUrl(uuid), { name });

  deleteCategory = (uuid: string): Observable<void> =>
    this.http.delete<void>(this.apiService.getAgentCategoryDetailUrl(uuid));
}
